/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import styles from './TestEnvironmentBanner.module.scss';

export function TestEnvironmentBanner() {
    const showTestEnvBanner = process.env?.FEATURES?.showTestBanner || false;

    return showTestEnvBanner ? (
        <section
            aria-label="Test Environment Banner"
            data-component="TestEnvironmentBanner"
            className={styles.testBanner}
        >
            {`${process.env.SITE_NAME} Test Environment`}
        </section>
    ) : null;
}
